export const normalizeOnChangeValue = (value: any, normalize: any) => {
  if (normalize) return normalize(value);
  return value;
};

export const onlyNumbers = (value: any) => {
  const onlyNums = value.replace(/[^\d]/g, '');
  return onlyNums ? parseInt(onlyNums) : undefined;
};
